const requiredFieldsError = 'Debe ingresar todos los campos requeridos [*]';

const hasValue = value => {
	if (value === undefined || value === null) return false;
	if (typeof value === 'string') return value.trim().length > 0;
	if (typeof value === 'number') return Number.isFinite(value);
	if (Array.isArray(value)) return value.length > 0 && value.every(hasValue);
	return true;
};

export function requestGenerateReportValidator(payload = {}, reportParams) {
	const { reportId, reportTable, toEmails, params } = payload || {};

	if (
		!reportId ||
		!reportTable ||
		!Array.isArray(toEmails) ||
		toEmails.length === 0 ||
		!params ||
		typeof params !== 'object' ||
		Array.isArray(params)
	) {
		return requiredFieldsError;
	}

	const checkInvalidParam = param => {
		const reportParam = reportParams[param];
		if (!reportParam?.required) return false;

		const valueParam = params[param];
		if (reportParam.type === 'array' || reportParam.multiple) {
			return !Array.isArray(valueParam) || !hasValue(valueParam);
		}

		return !hasValue(valueParam);
	};

	if (reportParams) {
		const reportParamKeys = Object.keys(reportParams);
		const incompleteParam = reportParamKeys.find(param =>
			checkInvalidParam(param)
		);

		if (incompleteParam) {
			return requiredFieldsError;
		}
	}

	return null;
}
